<template>
  <div class="invoice-gored-bd">
    <custom-tab v-model="tab" :list="tabList" @change="onTab" style="margin: -24px 0 24px -24px; width: calc(100% + 48px)"></custom-tab>
    <!-- 申请信息 -->
    <div v-if="tab === '1'">
      <div>
        <div class="item-title">{{ $t('components_invoice_gored.sqhcdzd') }}</div>
        <el-button type="primary" style="margin-bottom: 12px" @click="onSelectInvoice" :disabled="model.type === 'watch' || hasBillType19">{{ $t('components_invoice_gored.tjchzd') }}</el-button>
        <div class="table-bd" style="margin-bottom: 22px">
          <custom-table index :data="tableList" tableCode="invoiceGoredApply" @sort="sortChange" @filter="filterChange" :slots="['invoiceAmount', 'redInvoiceAmount', 'action']">
            <template slot="action" slot-scope="scope">
              <el-button :disabled="model.type === 'watch' || scope.$index === 0 || hasBillType19" type="text" size="mini" @click="deleteRow(scope.$index)">{{ $t('Common.com_delete') }}</el-button>
            </template>
          </custom-table>
        </div>
        <div style="font-weight: 500; margin-bottom: 22px; font-size: 13px">{{ $t('components_invoice_gored.hjchje') }}： ￥{{ totalAmount }}</div>
      </div>
    </div>
    <!-- 预计红字发票 -->
    <div v-if="tab === '2'">
      <invoice-ticket :data="invoiceRedPreview" :type="invoiceRedPreview.isRedInvoice"></invoice-ticket>
    </div>
    <!-- 申请描述 -->
    <el-form :model="form" :inline="true" :rules="rules" ref="form" label-width="86px">
      <div>
        <el-form-item :label="$t('components_invoice_gored.chsqbh')" prop="redApprovalNum">
          <el-input :disabled="model.type === 'watch'" placeholder="" v-model="form.redApprovalNum" style="width: 260px"></el-input>
        </el-form-item>
      </div>
      <!-- <el-form-item :label="$t('pi_gored_sqms')" prop="desc">
        <el-input type="textarea" :rows="3" :disabled="model.type === 'watch'" :placeholder="$t('pi_gored_qsrbgdyy')" v-model="form.desc" style="width: 636px"></el-input>
      </el-form-item> -->
    </el-form>
    <!--添加冲红明细弹窗 -->
    <invoice-gored-select-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="addSuccess"></invoice-gored-select-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import invoiceTicket from '@/pages/fms/components/invoice_ticket.vue';
import invoiceGoredSelectDialog from '@/pages/fms/components/invoice_gored_select_dialog.vue';

export default {
  components: { invoiceTicket, invoiceGoredSelectDialog },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '',
        };
      },
    },
  },
  data() {
    return {
      form: {
        redInvoiceId: '',
        billMonthList: [],
        redApprovalNum: '',
        desc: '',
      },
      rules: {},
      dialogVisible: false,
      dialogModel: {},
      tab: '1',
      tableList: [],
      invoiceInfo: {},
      invoiceRedPreview: {},
    };
  },
  computed: {
    totalAmount: vm => vm.tableList.reduce((pre, t) => t.canableRedAmount + pre, 0).toFixed(2),
    hasBillType19: vm => vm.tableList.some(t => `${t.billType}` === '19'),
    tabList() {
      return [
        {
          name: this.$t('components_invoice_gored.shen_qing_xin_xi'),
          value: '1',
        },
        {
          name: this.$t('components_invoice_gored.yjhzfp'),
          value: '2',
        },
      ];
    },
  },
  mounted() {
    this.getInvoiceDetail();
  },
  methods: {
    // 获取编辑详情
    getInvoiceDetail: function () {
      if (this.model.changeId) {
        this.$getJSON(`${apis.invoiceGoRedNewDetail}/${this.model.changeId}`).then((res) => {
          this.invoiceInfo = res.data || {};
          this.tableList = res.data.invoiceBillMonthViewList || [];
          this.form.redApprovalNum = res.data.redApprovalNum;
          this.form.desc = res.data.desc;
        });
      } else {
        this.tableList = this.model.row;
      }
    },
    // 添加冲红账单
    onSelectInvoice: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('components_invoice_gored.xuan_ze_chong_hong');
      this.dialogModel.payableOrgId = this.tableList[0].payableOrgId;
      this.dialogModel.buyerNumber = this.tableList[0].buyerNumber;
      this.dialogModel.billMonthIds = this.tableList.map(t => t.billMonthId);
      this.dialogVisible = true;
    },
    // 选择账单成功
    addSuccess: function (rows) {
      const list = [...this.tableList, ...rows];
      const amounts = list.reduce((pre, t) => t.canableRedAmount + pre, 0).toFixed(2);
      if (amounts > 130000) {
        this.$message.error(this.$t('components_invoice_gored.kpjebncg13w'));
        return;
      }
      this.tableList = [...this.tableList, ...rows];
    },
    // 删除单行账单
    deleteRow: function (i) {
      this.tableList.splice(i, 1);
    },
    // 查看预计红字发票
    onTab: function (num) {
      if (num !== '2') {
        return;
      }
      if (this.model.type === 'watch') {
        this.invoiceRedPreview = this.invoiceInfo;
      } else {
        this.getInvoiceList();
      }
    },
    // 获取预计红字发票信息
    getInvoiceList: function () {
      const billMonthList = this.tableList.map(t => ({
        billMonthId: t.billMonthId,
        goRedAmount: t.canableRedAmount,
        refundMonthId: t.refundMonthId,
      }));
      this.$postJSON(apis.invoiceGoRedNewPreview, {
        redInvoiceId: this.model.changeId,
        billMonthList: billMonthList,
        redApprovalNum: this.form.redApprovalNum,
        desc: this.form.desc,
      }).then((res) => {
        this.invoiceRedPreview = res.data || {};
      });
    },
    // 确认保存（草稿、提交）
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.tableList.length) {
          this.$message.error(this.$t('components_invoice_gored.qxzchmx'));
          return;
        }
        this.form.billMonthList = this.tableList.map(t => ({
          billMonthId: t.billMonthId,
          goRedAmount: t.canableRedAmount,
          refundMonthId: t.refundMonthId,
        }));
        this.form.redInvoiceId = this.model.changeId || null;
        this.$postJSON(apis.invoiceGoRedNewDraft, this.form).then((res) => {
          if (approve) {
            res.data.changeId = res.data.invoiceId; // 做个兼容，提交审批用invoiceId
            this.onSubmit(res.data);
            return;
          }
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success', this.form);
        });
      });
    },
    // 提交审批
    onSubmit(row) {
      this.$postJSON(
        `${apis.apsApproveApprovalApproveStart}/red_application/${row.changeId}`,
        {
          title: [`【${row.invoiceId}】`, this.getDicValue('approval_type', 'red_application')].join(' '),
          applyReason: row.invoiceRemark,
        },
        true
      ).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss"></style>
